import { env } from '@/env';

interface MobilePaymentNoticeProps {
  /** What the user would do on the web, e.g. "pay charges". */
  action?: string;
}

/**
 * Read-only notice shown in place of a payment action when self-serve payments
 * are disabled (the native app — see `@/lib/native/payments`). It tells the
 * user to complete the action on the Pirouette website.
 *
 * The web origin is derived from `VITE_APP_BASE_URL` and rendered as plain
 * TEXT, never a clickable `target="_blank"` link: inside the Capacitor shell a
 * navigation link would replace the app's webview with the destination and
 * strand the user (we deliberately don't depend on @capacitor/browser to open
 * an external tab). If the base URL is unset we fall back to a generic phrase.
 */
export function MobilePaymentNotice({ action = 'make payments' }: MobilePaymentNoticeProps) {
  const base = env.VITE_APP_BASE_URL?.replace(/\/+$/, '');
  // Strip the protocol for a clean host-only display (e.g. "app.pirouettehq.com").
  const host = base ? base.replace(/^[a-z]+:\/\//i, '') : null;

  return (
    <div
      role="note"
      className="rounded-[var(--radius-md)] border border-dashed border-[var(--color-border)] bg-[var(--color-surface-muted,transparent)] p-3 text-[var(--color-ink-muted)] text-[var(--text-sm)]"
    >
      To {action}, visit{' '}
      {host ? (
        <span className="font-medium text-[var(--color-ink)]">{host}</span>
      ) : (
        'the Pirouette website'
      )}{' '}
      in your browser.
    </div>
  );
}
